export default "__VITE_ASSET__XNVf7OjJ__"